import { FC, Fragment } from 'react';
import { BorrowerStore } from '@apply/store';

export type AppraisalInvoiceProps = {
    invoice: BorrowerStore.Types.InvoiceLine[]; // TODO: add Invoice type
    total: number;
};

export const AppraisalInvoice: FC<AppraisalInvoiceProps> = ({ invoice = [], total }) => {
    const totalUnderWritings = invoice.reduce(
        (totalUnderWritings, listing) => (totalUnderWritings = totalUnderWritings + listing.underwritingFee),
        0
    );
    return (
        <div className='row appraisal-section appraisal-invoice-section'>
            <div className='columns'>
                <div className='title'>
                    Invoice
                    {totalUnderWritings != 0 ? (
                        <div className='appraisal-invoice-notice'>Valuation Fee + Underwriting Fee per property.</div>
                    ) : (
                        <div className='appraisal-invoice-notice'>Valuation Fee per property.</div>
                    )}
                </div>
                <div className='appraisal-invoice-content'>
                    {totalUnderWritings != 0
                        ? invoice.map((listing, index) => (
                              <Fragment key={index}>
                                  <div className='invoice-type'>
                                      ({listing.index}) {listing.address1}
                                      {listing.address2?.length ? `, ${listing.address2}` : ''}{' '}
                                      {BorrowerStore.Types.StructureTypeDescriptions[listing.structureType]}
                                  </div>
                                  <div className='invoice-cost'>
                                      ${listing.cost} + ${listing.underwritingFee} =
                                  </div>
                                  <div className='invoice-subtotal'>
                                      ${Number(listing.cost) + Number(listing.underwritingFee)}
                                  </div>
                                  <div className='invoice-notes'>
                                      {listing.cost == 0 && listing.underwritingFee == 0 ? '(pay at closing)' : ''}
                                  </div>
                              </Fragment>
                          ))
                        : invoice.map((listing, index) => (
                              <Fragment key={index}>
                                  <div className='invoice-type'>
                                      ({listing.index}) {listing.address1}
                                      {listing.address2?.length ? `, ${listing.address2}` : ''}{' '}
                                      {BorrowerStore.Types.StructureTypeDescriptions[listing.structureType]}
                                  </div>
                                  <div className='invoice-cost' />
                                  <div className='invoice-subtotal'>${Number(listing.cost)}</div>
                                  <div className='invoice-notes'>{listing.cost == 0 ? '(pay at closing)' : ''}</div>
                              </Fragment>
                          ))}

                    <div className='invoice-type invoice-total'></div>
                    <div className='invoice-cost invoice-total'>Total:</div>
                    <div className='invoice-subtotal invoice-total'>${total}</div>
                    <div className='invoice-notes invoice-total'></div>
                </div>
            </div>
        </div>
    );
};
